<template>
    <footer>
        <!-- 支持机构 -->
        <div class="support-organ">
            <div class="main">
                <div class="support-organ-main">
                    <div class="title" style="position: relative">
                        友情链接
                        <strong style="color: #2763ce; font-size: 15px">》</strong>
                        <b style="
                                width: 1112px;
                                height: 1px;
                                background: #cccccc;
                                position: absolute;
                                top: 17px;
                                left: 90px;
                            "></b>
                    </div>
                    <ul class="list">
                        <li v-for="(item, index) in organList" :key="index" class="item">
                            <a target="_black" :href="item.url">{{
                                item.name
                            }}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- footer -->
        <div class="footer-main" style="
                height: 94px;
                padding: 0;
                border-bottom: 1px solid #fff;
                text-align: center;
            ">
            <img src="../../static/images/666.png" alt="" height="68px;" style="margin-top: 10px; margin-right: 10px" />
            <img src="../../static/images/100.png" alt="" height="78px;" style="margin-top: 8px" />
        </div>

        <div class="footer-main">
            <ul class="main" style="display: flex">
                <li v-for="(item, index) in navList" :key="index" style="flex: 1; text-align: center; position: relative">
                    <h6 style="font-size: 18px; color: #fff; line-height: 34px">
                        {{ item.title }}
                    </h6>
                    <ul>
                        <li v-for="(subItem, inx) in item.children" :key="inx" @click="routeSubTo(subItem)">
                            <span>{{ subItem.title }}</span>
                        </li>
                    </ul>
                    <div class="dsx" v-if="index < navList.length - 1"></div>
                </li>
            </ul>
        </div>

        <div class="footer-main" style="background: #393939; text-align: center">
            <div class="main">
                <div class="clearfix">
                    <div>
                        版权所有：中国演出行业协会&nbsp;&nbsp;&nbsp;&nbsp;
                        备案号：
                        <a href="http://beian.miit.gov.cn/" target="_black" style="color: #608be4">京ICP备17032706-2</a>
                    </div>
                    <div>
                        地址：北京市东城区东城区禄米仓胡同71号7号楼301&nbsp;&nbsp;&nbsp;&nbsp;邮编：100010
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    data() {
        return {
            // 支持机构
            organList: [
                {
                    name: "中华人民共和国文化和旅游部",
                    url: "https://www.mct.gov.cn/",
                },
                {
                    name: "中华人民共和国民政部",
                    url: "https://www.mca.gov.cn/",
                },
                {
                    name: "中国文化网",
                    url: "https://cn.chinaculture.org/",
                },
                {
                    name: "中国文化传媒网",
                    url: "https://www.ccdy.cn/",
                },
                {
                    name: "全国文化市场技术监管与服务平台",
                    url: "https://ccm.mct.gov.cn/ccnt/hbase/index.html",
                },
            ],

            navList: [
                {
                    name: "AboutUsList",
                    url: "/index/AboutUsList",
                    title: "协会概况",
                    icon: "ios-film-outline",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "协会简介",
                            id: "8",
                            contentType: "富文本",
                            url: "/index/AboutUsList",
                            type: "1",
                        },
                        {
                            title: "协会章程",
                            id: "7",
                            contentType: "富文本",
                            url: "/index/AboutUsList",
                            type: "1",
                        },
                        {
                            title: "主要负责人",
                            id: "9",
                            contentType: "富文本",
                            url: "/index/AboutUsList",
                            type: "1",
                        },
                        {
                            title: "驻会机构",
                            id: "1552166349579501570",
                            contentType: "富文本",
                            url: "/index/AboutUsList",
                            type: "1",
                        },
                        {
                            title: "协会分支机构",
                            id: "1578634605600268290",
                            contentType: "简单列表",
                            url: "/index/AboutUsList",
                            type: "1",
                        },
                        {
                            title: "协会历届领导机构",
                            id: "1584857206903312385",
                            contentType: "简单列表",
                            url: "/index/AboutUsList",
                            type: "1",
                        },
                        {
                            title: "公示信息",
                            id: "1592798884993335298",
                            contentType: "简单列表",
                            url: "/index/AboutUsList",
                            type: "1",
                        },
                    ],
                },
                {
                    name: "DynamicList",
                    url: "/index/DynamicList",
                    title: "行业动态",
                    icon: "ios-printer-outline",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "通知公告",
                            id: "1552487425756987393",
                            contentType: "简单列表",
                            url: "/index/DynamicList",
                            type: "1",
                        },
                        {
                            title: "市场观察",
                            id: "1552477578156048385",
                            contentType: "标准列表",
                            url: "/index/DynamicList",
                            type: "1",
                        },
                        {
                            title: "媒体报道",
                            id: "1552487757262192642",
                            contentType: "标准列表",
                            url: "/index/DynamicList",
                            type: "1",
                        },
                        {
                            title: "国际视野",
                            id: "1552487847674609665",
                            contentType: "标准列表",
                            url: "/index/DynamicList",
                            type: "1",
                        },
                        {
                            title: "热点专题",
                            id: "1552487651599286274",
                            contentType: "图片+列表",
                            url: "/index/DynamicList",
                            type: "1",
                        },
                    ],
                },
                {
                    name: "PolicyList",
                    url: "/index/PolicyList",
                    title: "政策法规",
                    icon: "ios-briefcase-outline",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "政策文件",
                            id: "1552554113475035137",
                            contentType: "简单列表",
                            url: "/index/PolicyList",
                            type: "1",
                        },
                        {
                            title: "法律法规",
                            id: "1552554060823937025",
                            contentType: "简单列表",
                            url: "/index/PolicyList",
                            type: "1",
                        },
                    ],
                },
                {
                    name: "PartyBuildingList",
                    url: "/index/PartyBuildingList",
                    title: "党建之窗",
                    icon: "ios-barcode-outline",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "学习资料",
                            id: "1562359332169953282",
                            contentType: "简单列表",
                            url: "/index/PartyBuildingList",
                            type: "1",
                        },
                        {
                            title: "党建活动",
                            id: "1592826663357104130",
                            contentType: "简单列表",
                            url: "/index/PartyBuildingList",
                            type: "1",
                        },
                    ],
                },
                {
                    name: "ResearchList",
                    url: "/index/ResearchList",
                    title: "行业研究",
                    icon: "ios-calendar-outline",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "行业年报",
                            id: "1552554168751767554",
                            contentType: "简单列表",
                            url: "/index/ResearchList",
                            type: "1",
                        },
                        {
                            title: "市场监测",
                            id: "1552554218177445889",
                            contentType: "简单列表",
                            url: "/index/ResearchList",
                            type: "1",
                        },
                    ],
                },
                {
                    name: "StandardList",
                    url: "/index/StandardList",
                    title: "标准规范",
                    icon: "ios-list-outline",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "国标行标",
                            id: "1552553767805665281",
                            contentType: "简单列表",
                            url: "/index/StandardList",
                            type: "1",
                        },
                        {
                            title: "团体标准",
                            id: "1552553886944870402",
                            contentType: "简单列表",
                            url: "/index/StandardList",
                            type: "1",
                        },
                        {
                            title: "自律规范",
                            id: "1552553938815827969",
                            contentType: "简单列表",
                            url: "/index/StandardList",
                            type: "1",
                        },
                    ],
                },

                // {
                //     name: "",
                //     url: "http://182.92.202.71:9201",
                //     title: "考试中心",
                //     style: "color:#366df0",
                // },

                {
                    name: "MeetingHome",
                    url: "/index/MeetingHome",
                    title: "会议活动",
                    icon: "ios-bookmarks-outline",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "协会会议",
                            id: "15",
                            contentType: "简单列表",
                            url: "/index/MeetingHome",
                            type: "1",
                        },
                        {
                            title: "演艺博览会",
                            id: "16",
                            contentType: "简单列表",
                            url: "/index/MeetingHome",
                            type: "1",
                        },
                        {
                            title: "音乐人才扶持",
                            id: "17",
                            contentType: "简单列表",
                            url: "/index/MeetingHome",
                            type: "1",
                        },
                        {
                            title: "剧场大会",
                            id: "18",
                            contentType: "简单列表",
                            url: "/index/MeetingHome",
                            type: "1",
                        },

                        {
                            title: "非遗传播",
                            id: "1595269047878012930",
                            contentType: "简单列表",
                            url: "/index/MeetingHome",
                            type: "1",
                        },
                        {
                            title: "网络表演高峰论坛",
                            id: "19",
                            contentType: "简单列表",
                            url: "/index/MeetingHome",
                            type: "1",
                        },
                        {
                            title: "其他活动",
                            id: "1592808873162080258",
                            contentType: "简单列表",
                            url: "/index/MeetingHome",
                            type: "1",
                        },
                    ],
                },
                // {
                //     name: "CourseHome",
                //     url: "/index/CourseHome",
                //     title: "学习中心",
                //     style: "color:#366df0",
                // },

                {
                    name: "TrainList",
                    url: "",
                    title: "行业培训",
                    style: "color:#366df0",
                    icon: "ios-browsers-outline",
                    children: [
                        {
                            title: "培训动态",
                            url: "/index/TrainingTrendsList",
                            type: "2",
                        },
                        {
                            title: "剧院剧场",
                            url: "/index/Project",
                            type: "2",
                        },
                        {
                            title: "演出经纪",
                            url: "/index/Project",
                            type: "2",
                        },
                        {
                            title: "舞台舞美",
                            //  url: "",
                            url: "/index/WM_HomePage",
                            type: "2",
                        },
                        {
                            title: "网络表演",
                            // url: "/index/Project",
                            url: "/index/NP_HomePage",
                            type: "2",
                        },
                        {
                            title: "艺术普及教育",
                            url: "/index/Project",
                            type: "2",
                        },
                    ],
                },
            ],
        };
    },
    methods: {
        handlePath(item) {
            this.$router.push({
                path: item.path,
            });
        },

        routeSubTo(item) {
            if (item.type == 1) {
                this.$router.push({
                    path: item.url,
                    query: {
                        activeName: item.title,
                        id: item.id,
                        contentType: item.contentType,
                    },
                });
            }
            if (item.type == 2) {
                if (item.url) {
                    this.$router.push({
                        path: item.url,
                        query: {
                            name: item.title,
                        },
                    });
                    return;
                    let routeUrl = this.$router.resolve({
                        path: item.url,
                    });
                    window.open(routeUrl.href, "_blank");
                } else {
                    this.$router.push({
                        path: item.url,
                        query: {
                            name: item.title,
                        },
                    });
                    return;
                    let routeUrl = this.$router.resolve({
                        path: "/index/Project",
                    });
                    window.open(routeUrl.href, "_blank");
                }
            }
        },
    },
};
</script>

<style scoped>
footer {
    width: 100%;
    color: #fff;
    line-height: 30px;
}

footer .main {
    font-size: 14px;
}

footer .main span {
    /* color: #b1daf5; */
    color: #fff;
    cursor: pointer;
}

footer .main span:hover {
    text-decoration: underline;
}

footer a {
    color: #d3d3d7;
}

footer a:hover {
    color: #000;
}

.dsx {
    width: 1px;
    height: 280px;
    background: url("../../static/images/dsx.png") no-repeat;
    position: absolute;
    right: 0;
    top: -21px;
}

.support-organ {
    width: 100%;
    height: auto;
    background: #f9f9f9;
    border-top: 2px solid #e9e9e9;
}

.support-organ-main {
    padding: 30px 0;
}

.support-organ-main .title {
    color: #323232;
    font-size: 18px;
}

.support-organ-main .list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
}

.support-organ-main .item {
    line-height: 30px;
    font-size: 14px;
}

.support-organ-main .item a {
    padding: 0 8px;
    border-right: 1px solid #666666;
    color: #666666;
}

.support-organ-main .item:last-child a {
    border-right: 0;
}

.support-organ-main .item a:hover {
    color: #2763ce;
}

.footer-main {
    padding: 30px 0;
    background: #2763ce;
}

.footer-main .title {
    height: 33px;
    text-align: center;
    background: url(../../static/images/xian.jpg) left center repeat-x;
}

.footer-main .ft_nav {
    display: flex;
    flex-wrap: wrap;
    margin-top: 16px;
}

.footer-main .ft_nav li {
    margin-right: 15px;
}

footer p {
    color: #d3d3d7;
    font-size: 14px;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/MainnFooter.vue